module.exports = __webpack_public_path__ + "img/sleep.70597d84.png";